/*eslint no-unused-vars: ["error", { "varsIgnorePattern": "[iF]ragment" }]*/

import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import {
  SiteVariablesFragment,
  PrivacyPageFragment,
} from "src/components/QueryFragments"
import "src/assets/scss/material-kit-react.scss"

import PrivacyPageView from "../views/PrivacyPage"

const PrivacyPage = ({ location }) => {
  const {
    contentfulWebsiteGlobalVariables,
    contentfulPagePrivacy,
  } = useStaticQuery(
    graphql`
      query {
        contentfulWebsiteGlobalVariables {
          ...SiteVariablesFragment
        }
        contentfulPagePrivacy {
          ...PrivacyPageFragment
        }
      }
    `
  )
  return (
    <PrivacyPageView
      siteVariables={contentfulWebsiteGlobalVariables}
      pageContent={contentfulPagePrivacy}
      location={location}
    />
  )
}

export default PrivacyPage
